import { Outlet } from "react-router-dom"

export const LayoutUser = () => {
  return (
    <main className="bg-background flex h-screen items-center justify-center overflow-y-auto">
      <Outlet />
    </main>
  )
}
